module.exports = __webpack_public_path__ + "static/media/rebirth_24.1381af03.jpg";